import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { Typography } from '@naf-simba/building-blocks-typography';
import ResponsiveImage from '../../image/ResponsiveImage';
import { DynamicVideoPlayer } from '../../video-player/DynamicVideoPlayer';
import { CompetitionQuestion, CompetitionStyleVariant } from '../Competition.types';
import type { CloudinaryImageType, CloudinaryVideoType } from '../../../../../types/CloudinaryImageType';
import { getAnswerLabel } from '../Competition.utils';
import * as S from './CompetitionQuestionAndAnswers.styles';

interface CompetitionQuestionAndAnswersProps {
  question: CompetitionQuestion;
  selectedAnswerKey?: string;
  style: CompetitionStyleVariant;
  image?: CloudinaryImageType;
  video?: CloudinaryVideoType;
  onAnswerSelect: (questionKey: string, answerKey: string) => void;
  hasAnswered: boolean;
}

const CompetitionQuestionAndAnswers = ({
  question,
  selectedAnswerKey,
  style,
  image,
  video,
  onAnswerSelect,
  hasAnswered,
}: CompetitionQuestionAndAnswersProps) => (
  <S.QuestionContainer>
    <Typography variant="titleM">Spørsmål:</Typography>
    <Typography variant="textMRegular">{question.question}</Typography>
    {video?.publicId && !image?.publicId && (
      <S.ImageWrapper>
        <DynamicVideoPlayer video={video} />
      </S.ImageWrapper>
    )}
    {!video?.publicId && image?.publicId && (
      <S.ImageWrapper>
        <ResponsiveImage imageId={image.publicId} altText={image.altText || image.caption || ''} />
      </S.ImageWrapper>
    )}
    <S.AnswersContainer>
      {question.answers.map((answer, index) => {
        const isSelected = selectedAnswerKey === answer.key;
        return (
          <S.AnswerButton
            key={answer.key}
            $style={style}
            $isSelected={isSelected}
            onClick={() => onAnswerSelect(question.key, answer.key)}
            disabled={hasAnswered}
          >
            <S.AnswerLabel $style={style} $isSelected={isSelected}>
              {getAnswerLabel(index)}
            </S.AnswerLabel>
            <Text tag="span" variant={TextVariant.Button}>
              {answer.answer}
            </Text>
          </S.AnswerButton>
        );
      })}
    </S.AnswersContainer>
  </S.QuestionContainer>
);

export default CompetitionQuestionAndAnswers;
